import React from "react";
import { Route, Switch } from "react-router-dom";
import { rootRoutes } from "routes";
import ScreenBaseReport from "./report";

const baseRoutes = rootRoutes.children.report.children;

const ScreenBase = () => {
	return (
		<Switch>
			<Route path={baseRoutes.report.path} component={ScreenBaseReport} />
		</Switch>
	);
};

export default ScreenBase;
